// Centralized environment-aware configuration for API and Socket URLs

// Production builds default to same-origin (empty string) — every real
// deployment (private-IP nginx, the cms.oculintech.com domain, a Cloudflare
// quick tunnel, etc.) proxies /api and the frontend from the same host the
// browser loaded the page from, so this needs no per-build env var to get
// right. A plain `npm run build` with zero env vars now produces a working
// build under ANY of those hosts — nobody has to remember a special flag.
//
// 'same-origin' is still accepted as an explicit override value (equivalent
// to leaving it unset) for any existing scripts/docs that reference it.
// Only set VITE_API_ORIGIN to an actual absolute URL if the frontend and
// backend are genuinely served from different origins (e.g. `vite preview`
// against a backend you're not proxying).
const rawApiOrigin = import.meta.env.VITE_API_ORIGIN;
export const API_ORIGIN: string =
  rawApiOrigin === 'same-origin' ? '' :
  rawApiOrigin ||
  (import.meta.env.DEV ? 'http://localhost:3000' : '');

export const API_URL: string =
  import.meta.env.VITE_API_URL || `${API_ORIGIN}/api`;

const rawSocketUrl = import.meta.env.VITE_SOCKET_URL;
export const SOCKET_URL: string =
  rawSocketUrl === 'same-origin' ? '' :
  rawSocketUrl || API_ORIGIN;

// Socket.IO treats a path segment in the connection URL as a namespace, not
// a proxy prefix, so a reverse-proxy subpath (e.g. /cms) must be passed here
// instead of folded into SOCKET_URL.
export const SOCKET_PATH: string =
  import.meta.env.VITE_SOCKET_PATH || '/socket.io/';

export const CMO_BASE_URL: string =
  import.meta.env.VITE_CMO_BASE_URL || 'http://192.168.10.100:8085';

